import React from 'react';
import styled from 'styled-components';
import { BE_BASE_URL } from '@Utils/config';
import { isEmpty, orderBy } from 'lodash';
import { Field } from 'redux-form';
import { CommonDropdownOutlined, OutlinedTextFields } from '@Components';
import { r_maxLength } from '@Utils/validation';
import { getValidation } from '@Utils/templates/address';
import { isValidBeneAddressInput } from '../../../../beneficiary-flow/pages/recipient-address/utils/methods';

const FieldWrapper = styled.div<{ width: string }>`
  width: ${(props: any) => props.width};
`;
export const renderFuncAddressFields = (field: any, values: any) => {
  if (field) {
    if (
      field.render &&
      (field.render.visibility === 'VISIBLE' ||
        field.render.visibility === 'CONDITIONAL' ||
        field.render.visible)
    ) {
      const renderObj = field.render;
      const validationObj = field.validation;
      const apiConfig =
        'url' in (field.api || {}) ? field.api : 'url' in (field.render || {}) ? field.render : {};

      let apiUrl = '';
      if (!isEmpty(apiConfig)) {
        if (!isEmpty(apiConfig['version'])) {
          apiUrl = `${BE_BASE_URL}${apiConfig['version']}${apiConfig['url']}`;
        } else if (isEmpty(apiConfig['version'])) {
          apiUrl = `${BE_BASE_URL}v1${apiConfig['url']}`;
        }
      }

      let key = `${values?.details_selected || field.sequence}_${renderObj['value_field_name']}`;

      switch (renderObj.field || renderObj.type) {
        case 'text': {
          return (
            <FieldWrapper width={'100%'}>
              <Field
                name={renderObj['value_field_name']}
                bindToThisObject={values?.[renderObj['value_field_name']]}
                type="text"
                component={OutlinedTextFields}
                maxWidth={'100%'}
                normalize={
                  validationObj?.length?.max ? r_maxLength(validationObj.length.max) : undefined
                }
                validate={[
                  ...getValidation(validationObj, renderObj['value_field_name']),
                  isValidBeneAddressInput
                ]}
                showSuccessIcon={values?.[renderObj['value_field_name'] + '_success']}
                disabled={values?.[renderObj['value_field_name'] + '_disabled']}
                showEditIcon={values?.[renderObj['value_field_name'] + '_disabled']}
                placeholder={renderObj.label}
                tooltip={renderObj.tooltip}
                key={key}
                id={key}
                note={renderObj?.note}
                destination_currency={values?.currency_code}
              />
            </FieldWrapper>
          );
        }
        case 'dropdown': {
          return (
            <FieldWrapper width={'100%'}>
              <Field
                bindToThisObject={values?.[renderObj['value_field_name']]}
                type="text"
                name={renderObj['value_field_name']}
                component={CommonDropdownOutlined}
                maxWidth={'100%'}
                placeholder={renderObj.label}
                className={`theme-dropdown`}
                url={apiUrl}
                width={'100%'}
                key={key}
                id={key}
              />
            </FieldWrapper>
          );
        }

        default:
          return null;
      }
    }
    return null;
  }
};

export const sortFields = (json: any) => {
  const arr = Object.keys(json).map((el) => {
    return json[el];
  });
  return orderBy(arr, 'render.sequence', 'asc');
};
